import { SvgIconBase, } from "./Base";

export const ArrowRight = () => {
	return (
		<SvgIconBase xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="brkt arrow-right" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
			<title>Arrow Right</title>
			<path transform="translate(2 2) scale(-1 1) translate(-20 0)" fillRule="evenodd" clipRule="evenodd" d="M8.86367 3.63642C9.15656 3.92932 9.15656 4.40419 8.86366 4.69708L4.31067 9.25002H17.5C17.9142 9.25002 18.25 9.58581 18.25 10C18.25 10.4142 17.9142 10.75 17.5 10.75H4.31066L8.86366 15.303C9.15656 15.5959 9.15656 16.0708 8.86366 16.3637C8.57077 16.6566 8.0959 16.6566 7.803 16.3637L1.96967 10.5304C1.82902 10.3897 1.75 10.1989 1.75 10C1.75 9.80111 1.82902 9.61034 1.96967 9.46969L7.80301 3.63642C8.0959 3.34352 8.57077 3.34353 8.86367 3.63642Z" />
		</SvgIconBase>
	);
};

